import { Map } from 'immutable';
import actions from './actions';
/**
 * Things you should never do inside a reducer:
1. Mutate its arguments;
2. Perform side effects like API calls and routing transitions;
3. Call non-pure functions, e.g. Date.now() or Math.random().
 */


const initState = new Map({
  //AskDigit Pojo - copy from collection
  ask_digit: '',
  hotDeals: '',

  //Control form operations 
  success: false,
  msg: '',
  result: [],
  listresult: [],
  listsuccess: false,
  total_count: 0,
  page: 1,
});


export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.ITEM_ADD_SUCCESS:
      return state
        .set('success', action.success)
        .set('msg', action.msg);
    case actions.COUNTRY_READ_SUCCESS:
      return state
        .set('success', action.success)
        .set('msg', action.msg)
        .set('data', action.data)
        .set('totalCount', action.total_count)
        .set('page',action.page);
    case actions.COUNTRY_ADD_NEW:
      return state
        .set('success', action.success)
        .set('msg', action.msg);
    case actions.COUNTRY_ITEM_SUCCESS:
      return state
        .set('success', action.success)
        .set('result', action.result);
    default:
      return state;
  }
}
